module.exports = __webpack_public_path__ + "img/gerüstbohlen-bank-konfigurator.70d560ce.jpeg";